import * as tslib_1 from "tslib";
import loader from "@/components/loader.vue";
import { Action, Getter } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.displayName = "";
        this.changeEmailDialog = false;
    }
    mounted() {
        this.displayName = this.fbUser.displayName;
    }
    get canEditEmail() {
        return this.providerID == "password";
    }
    changeEmail() {
        this.changeEmailDialog = true;
    }
    get dirty() {
        return this.displayName != this.fbUser.displayName;
    }
    async save() {
        this.loading = true;
        try {
            await this.updateFbProfile({
                displayName: this.displayName
            });
        }
        catch (err) {
            this.loading = false;
            return;
        }
        // this.fbUser.displayName = this.displayName
        this.loading = false;
    }
};
tslib_1.__decorate([
    Getter("auth/account")
], widget.prototype, "account", void 0);
tslib_1.__decorate([
    Getter("auth/fbUser")
], widget.prototype, "fbUser", void 0);
tslib_1.__decorate([
    Getter("auth/providerID")
], widget.prototype, "providerID", void 0);
tslib_1.__decorate([
    Action("auth/updateFbProfile")
], widget.prototype, "updateFbProfile", void 0);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            dialogChangeEmail: () => import(/* webpackChunkName: "dialog-changeEmail" */ "@/dialogs/changeEmail.vue")
        }
    })
], widget);
export default widget;
